var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5125 9.72184L13.0125 2.90621C12.7359 2.65324 12.3747 2.51294 12 2.51294C11.6252 2.51294 11.264 2.65324 10.9875 2.90621L3.48746 9.72184C3.3339 9.86232 3.21125 10.0332 3.12733 10.2237C3.0434 10.4141 3.00002 10.62 2.99996 10.8281V19.4625C2.99386 19.8406 3.12737 20.2078 3.37496 20.4937C3.51548 20.6535 3.68858 20.7814 3.88263 20.8687C4.07667 20.956 4.28717 21.0008 4.49996 21H8.99996C9.19887 21 9.38963 20.9209 9.53029 20.7803C9.67094 20.6396 9.74996 20.4489 9.74996 20.25V15.75C9.74996 15.551 9.82897 15.3603 9.96963 15.2196C10.1103 15.079 10.301 15 10.5 15H13.5C13.6989 15 13.8896 15.079 14.0303 15.2196C14.1709 15.3603 14.25 15.551 14.25 15.75V20.25C14.25 20.4489 14.329 20.6396 14.4696 20.7803C14.6103 20.9209 14.801 21 15 21H19.5C19.7487 21.0022 19.994 20.9408 20.2125 20.8218C20.4502 20.6924 20.6487 20.5013 20.7873 20.2688C20.9258 20.0362 20.9993 19.7707 21 19.5V10.8281C20.9999 10.62 20.9565 10.4141 20.8726 10.2237C20.7887 10.0332 20.666 9.86232 20.5125 9.72184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.374fb241efd7e49226e8b33b95939548.svg";
export { ForwardRef as ReactComponent };